<div *ngIf="userProfile$ | async as userProfile">

  <ng-container *ngIf="userIsAdmin$ | async as isAdmin">
    <span *ngIf="isAdmin" class="admin-badge">Admin</span>
  </ng-container>

  <app-toolbar-button [matMenuTriggerFor]="menu" [buttonClass]="{'clickable':true}">
    <ng-container *ngIf="getPictureUrl(userProfile) | async as src;else letters">
      <img class="user-image bg-subtle-color align-self-center rounded-circle" [attr.src]="src | safe: 'url'" title="{{userProfile.displayName}}" />
    </ng-container>
    <ng-template #letters>
      <div class="user-image bg-subtle-color letters align-self-center rounded-circle position-relative d-inline-block align-middle" title="{{userProfile.displayName}}">
        <span class="mb-0 letters-text">{{ getPreferredNameLetters(userProfile) }}</span>
      </div>
    </ng-template>

    <i class="ml-2 user-image-chevron ms-Icon ms-Icon--ChevronDown align-middle" aria-hidden="true"></i>
  </app-toolbar-button>

  <mat-menu #menu="matMenu" [yPosition]="'below'" [xPosition]="'before'" [overlapTrigger]="'false'" class="user-menu-list">
    <div class="settings-list-item-displayname">
      <ng-container *ngIf="userProfile$ | async as user">
        <b>{{user.displayName}}</b>
        <br />
        {{user.userPrincipalName}}
      </ng-container>
    </div>
    <div class="settings-list-item">
      <button class="btn btn-link p-0" (click)="logOut()" i18n="user menu signout button@@user-menu-signout-button">Sign out</button>
    </div>
  </mat-menu>
  
</div>
